export default "/images/forsia.avif?8249d7ece81b7459a8b9ea96727efd52";